import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row } from '../server/layout/Row/index';
export function PanelHeader({ children, actions, padX = 'xl', padY = 'lg', minH, }) {
    return (_jsxs(Row, { justify: "space-between", align: "center", style: {
            padding: `var(--space-${padY}) var(--space-${padX})`,
            borderBottom: '1px solid var(--border)',
            ...(minH !== undefined ? { minHeight: minH, boxSizing: 'border-box' } : {}),
        }, children: [_jsx(Row, { gap: "md", align: "center", style: { minWidth: 0 }, children: children }), actions && (_jsx(Row, { gap: "sm", style: { flexShrink: 0 }, children: actions }))] }));
}
//# sourceMappingURL=PanelHeader.js.map